var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLoc(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.58509 3.79248C7.58509 5.68608 5.48442 7.65818 4.77902 8.26725C4.7133 8.31666 4.63331 8.34338 4.55109 8.34338C4.46887 8.34338 4.38887 8.31666 4.32316 8.26725C3.61775 7.65818 1.51709 5.68608 1.51709 3.79248C1.51709 2.98782 1.83674 2.21611 2.40573 1.64712C2.97471 1.07814 3.74642 0.758484 4.55109 0.758484C5.35575 0.758484 6.12746 1.07814 6.69645 1.64712C7.26543 2.21611 7.58509 2.98782 7.58509 3.79248Z",
    stroke: "#F0E1CE",
    strokeWidth: 0.7585,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.55108 4.93022C5.17944 4.93022 5.68883 4.42084 5.68883 3.79247C5.68883 3.16411 5.17944 2.65472 4.55108 2.65472C3.92272 2.65472 3.41333 3.16411 3.41333 3.79247C3.41333 4.42084 3.92272 4.93022 4.55108 4.93022Z",
    stroke: "#F0E1CE",
    strokeWidth: 0.7585,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoc);
export default __webpack_public_path__ + "static/media/loc.909e98b3ba9e242464a19832376c3156.svg";
export { ForwardRef as ReactComponent };